<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;margin-top: 1rem;" class="fontMS700 font-45 colorPrincipal">
            LA IMPRENTA, <br>
            LOS INCUNABLES Y ESTAMPAS<br>
            EN EL VIRREINATO DEL PERÚ<br>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio22/imprenta">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio22/imprenta">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio22/imprenta">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img width="80%" src="/assets/images/micrositio/micrositio22/IMPRENTA-000.jpg" style="margin-left:auto; display:block;">
    
</section>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 text-center font-24">
                    A INICIOS DE LA DÉCADA DE 1580 SE AUTORIZÓ LA IMPRESIÓN DE LIBROS
                    EN EL VIRREINATO DEL PERÚ. PARA ESOS MOMENTOS SE CONSOLIDABAN LOS
                    GRANDES CAMBIOS EN EL ÁMBITO ECONÓMICO, POLÍTICO Y SOCIAL
                    IMPLEMENTADOS POR EL VIRREY FRANCISCO DE TOLEDO (1569-1581), ADEMÁS,
                    SIGUIENDO LAS POLÍTICAS ECLESIÁSTICAS DE LA METRÓPOLI SE ESTABLECIÓ EL
                    III CONCILIO LIMENSE (1582-1583) DONDE SE DICTARON IMPORTANTES
                    DISPOSICIONES PARA EL IMPULSO DE ACTIVIDADES EVANGELIZADORAS.
                    <br><br>
                </p>
                <p class="fontMS100 text-justify font-24">
                    Estas circunstancias permitieron el desarrollo de la imprenta en Lima, desde donde se extendió 
                    al resto del virreinato. Las publicaciones realizadas constituyen importantes fuentes para el 
                    estudio del proceso de evangelización católica sobre los pueblos originarios, la visión de su 
                    organización cultural y social desde el punto de vista del conquistador, así como un registro 
                    de las lenguas quechua y aimara. Además, a través de la imprenta se produjeron grabados, entre 
                    los que destacan las imágenes religiosas que, insertadas en libros o de manera suelta, mantuvieron 
                    su vigencia, ya sea realizados en la técnica del tallado en madera o como estampas calcográficas 
                    (grabado en metal), que hará su aparición en Lima a partir del siglo XVII. Una parte de este 
                    valioso material bibliográfico es preservado en el Fondo Antiguo de la Biblioteca Nacional del Perú.
                </p>
            </div>
        </div>
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-2">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada4.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-8">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LOS PROCESOS DE IMPRESIÓN
                        </p>
                    </div>
                    <div class="col-sm-2">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada4.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS300 text-center colorPrincipal font-40">
                    DE LIBROS Y GRABADOS
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                </div>
                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS500 text-center font-24">
                            DURANTE LA EDAD MEDIA EUROPEA, EL SABER LEER NO ERA EXTENDIDO Y LOS
                            POCOS TEXTOS QUE HABÍA SÓLO PASABAN ENTRE LAS MANOS DE LOS
                            CLÉRIGOS Y LA NOBLEZA. LAS COPIAS DE LOS ESCRITOS EXTENSOS ERAN
                            REALIZADAS A MANO POR CALÍGRAFOS QUE TARDABAN AÑOS EN COPIAR UN
                            TOMO ENTERO. EN 1440, EL ALEMÁN JOHANNES GUTENBERG INTRODUCE LOS
                            TIPOS MÓVILES DE LETRAS EN MOLDES DE METAL EN EL PROCESO DE
                            IMPRESIÓN DE LIBROS.
                            <br><br>
                        </p>
                        <p class="fontMS100 text-justify font-24">
                            En el Virreinato del Perú, el italiano Antonio Ricardo instala la primera imprenta en Lima hacia
                            1584. La profesión de impresor colonial era compleja. Además de depender de la provisión del
                            papel y del buen funcionamiento de su máquina, debía coordinar todo el proceso con
                            encuadernadores y aprendices, sumando la presión de los autores por cumplir con las fechas de
                            entrega. Sin embargo, la principal preocupación del impresor limeño eran los permisos que
                            dependían de las autoridades virreinales y la censura de la iglesia a través del Tribunal de la
                            Inquisición. La trasgresión se podía pagar con multas, la confiscación de libros o los útiles de
                            impresión, la pérdida de la licencia, el destierro o la cárcel.
                            <br><br>
                        </p>
                    </div>
                </div>
                <div class=" row mt-5">
                    <div class="col-sm-12">
                        <div class="mb-5">
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio22/IMPRENTA-001.jpg">
                        </div>
                        <div>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio22/IMPRENTA-002.jpg">
                                <p class="fontMS100 text-justify font-20">
                                    <br>
                                    Calcografías del grabador y pintor Miguel Adame, fraile dominico. Primera representación gráfica
                                    de los trabajos de preparación de libro en una imprenta limeña. Impresos en “Parentación real al
                                    soberano…” publicación dedicada al ceremonial fúnebre del rey Carlos II de España en 1701. La
                                    calcografía comprende todas las técnicas de grabado sobre metal, independiente del método de
                                    impresión usado y la manera en que se obtiene la imagen sobre la matriz. Estas técnicas datan del
                                    s. XIV aunque los procesos básicos fueron usados desde mucho antes por orfebres y otros
                                    artesanos con fines distintos al de la impresión.
                                </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada4.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            EL TRABAJO ARTESANAL
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada4.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40">
                    DEL LIBRO ANTIGUO
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                </div>
                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS500 text-center font-24">
                            LAS TAPAS DEL LIBRO SE DENOMINAN CUBIERTA Y PUEDEN SER
                            ENCUADERNADAS DE FORMA SENCILLA O ARTÍSTICA. ÉSTA ÚLTIMA
                            ENCUADERNACIÓN CONSISTE EN DECORAR LAS CUBIERTAS MEDIANTE
                            IMPRESIONES DE RELIEVE CON DISTINTOS ESTILOS DE DIBUJO QUE SE
                            COMBINAN ENTRE SÍ Y ERA REALIZADA DE FORMA ARTESANAL.
                            <br><br>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6 mt-5">
                        <p class="fontMS100 text-justify font-24">
                            La parte que sostiene las hojas del libro es el lomo
                            y sus elementos decorativos se encuentran en las
                            casillas, que son espacios entre las costillas. El
                            tejuelo es la parte donde aparecen el título y el
                            nombre del autor, generalmente hecho de
                            fragmentos de piel o papel. La cofia que es la
                            prolongación del cuero del lomo en la parte
                            superior e inferior del libro.
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-6 libro">
                        <img class="size-img pi-10"
                            src="/assets/images/micrositio/micrositio22/IMPRENTA-003.jpg">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS100 font-24">
                            <span class="fontMS500 font-24">Partes internas:<br>La portada </span>
                            La portada, elemento fundamental para los coleccionista y bibliófilos pues su conservación define
                            el valor del libro y puede ser de tipo arquitectónico, heráldico o textual.
                            <br>
                        </p>
                        <p class="fontMS100 font-24">
                            <span class="fontMS500 font-24">El frontispicio </span>
                            es la página anterior a la portada que suele contener algún grabado, dibujo o
                            retrato representando una escena de cierta relevancia asociada a la publicación.
                            <br>
                        </p>
                        <p class="fontMS100 font-24">
                            <span class="fontMS500 font-24">El colofón </span>
                            va generalmente en la última página impar en la cual se imprime el lugar de impresión,
                            la fecha y el nombre de la imprenta. También incluye el escudo del impresor.
                        </p>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-sm-4">
                        <img width="100%" height="100%"
                            src="/assets/images/micrositio/micrositio22/IMPRENTA-034.png">
                        <p class="fontMS100Italic font-20 text-center">
                            Portada
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img width="100%" height="100%"
                            src="/assets/images/micrositio/micrositio22/IMPRENTA-035.png">
                        <p class="fontMS100Italic font-20 text-center">
                            Frontispicio
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img width="100%" height="100%"
                            src="/assets/images/micrositio/micrositio22/IMPRENTA-036.png">
                        <p class="fontMS100Italic font-20 text-center">
                            Colofón
                        </p>
                    </div>
                    <!--<div class="col-sm-12">
                        <img width="100%" height="100%"
                            src="/assets/images/micrositio/micrositio22/IMPRENTA-004.jpg">
                    </div>-->
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LOS INCUNABLES
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40">
                    PERUANOS
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                </div>
                <p class="fontMS500 text-center font-24">
                    <br><br>
                    SE REFIERE A AQUEL MATERIAL BIBLIOGRÁFICO IMPRESO EN LIMA ENTRE 1584 Y
                    1619 POR LOS PRIMEROS IMPRESORES DEL VIRREINATO DEL PERÚ.
                </p>

                <div class="row mt-5">
                    <div class="col-sm-6">
                        <img width="100%" class="pd-10"
                            src="/assets/images/micrositio/micrositio22/IMPRENTA-005.jpg">
                        <p class="fontMS100Italic font-20">
                            <br>
                            Ilustración del libro LOS INCUNABLES de Prince
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100 font-24">
                            <br><br>
                            Según la definición convencional, se consideran incunables (del latín incunabulae, en la cuna)
                            a los libros impresos con tipos móviles desde la aparición de la imprenta hasta el año 1500 
                            inclusive. El concepto de incunables peruanos está referido a los impresos publicados en nuestro
                            país, entre 1584 y 1619, por el turinés Antonio Ricardo y el español Francisco del Canto, este
                            término fue anotado por primera vez por Ricardo Palma en el primer libro impreso en el Perú y
                            Sudamérica, la Doctrina Christiana.
                        </p>
                        <p class="fontMS100 font-24">
                            <br>
                            La Biblioteca Nacional del Perú preserva 39 incunables, de los cuales diez corresponden a 
                            Antonio Ricardo y los restantes a Francisco Del Canto. Entre esas publicaciones destacan 
                            la trilogía catequística trilingüe, los diccionarios y gramáticas en quechua y aymara y 
                            obras literarias, religiosas e históricas. En el año 2011, esos valiosos tesoros bibliográficos
                            fueron inscritos en el registro de Memoria del Mundo de la Unesco para la región de América 
                            Latina y el Caribe, por lo que trascienden el nivel internacional porque se tornan en patrimonio
                            documental del mundo.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-sm-3 libro mt-3">
                <a href="https://hdl.handle.net/20.500.14428/33570" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio22/IMPRENTA-006.jpg">
                    <div class="overlay-img3">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Los primeros ensayos del arte de la imprenta y los incunables 
                                <br>
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-3 libro mt-3">
                <a href="https://hdl.handle.net/20.500.14428/34015" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio22/IMPRENTA-007.jpg">
                    <div class="overlay-img3">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                La imprenta de Lima (1548-1824). Tomo I
                                <br>
                            </span>
                            José Toribio Medina
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-3 libro mt-3">
                <a href="https://hdl.handle.net/20.500.14428/70663" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio22/IMPRENTA-008.jpg">
                    <div class="overlay-img3">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Incunables peruanos en la Biblioteca Nacional del Perú (1584-1619)
                                <br>
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-3 libro mt-3">
                <a href="https://hdl.handle.net/20.500.14428/70510" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio22/IMPRENTA-009.jpg">
                    <div class="overlay-img3">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Incunables peruanos en bibliotecas del país y del extranjero
                                <br>
                            </span>
                        </p>
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>


<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="\assets\images\general\LINEA_RESALTE_BLANCA.png" width="100%">
            </div>
            <div class="col-sm-12">
                <p class="fontMS500 text-justify font-24 mt-3 text-white">
                    <br><br>
                    “EL INVENTARIO [DEL TALLER DE ANTONIO RICARDO] DEMOSTRÓ LA
                    CUANTÍA Y CALIDAD DE SUS IMPLEMENTOS. TENÍA LETRAS DE DIVERSOS
                    DISEÑOS Y TAMAÑOS, CON LAS MATRICES DESTINADAS A EFECTUAR LAS
                    FUNDICIONES QUE LE PERMITIERAN MANTENER EL BUEN ESTADO DE LAS
                    QUE USABA EN LAS IMPRESIONES; RAMAS DE HIERRO, CHICAS Y GRANDES,
                    PARA ACOMODAR Y AJUSTAR LOS MOLDES TIPOGRÁFICOS; DOS PRENSAS;
                    CAJAS PARA ORDENAR LOS TIPOS; UTENSILIOS PARA FABRICAR TINTA Y
                    PARA ECHARLA SOBRE LAS FORMAS; E INCLUSIVE TABLONES SOBRE LOS
                    CUALES SE MOJABA EL PAPEL ANTES DE LA IMPRESIÓN, Y CORDELES DE
                    LOS CUALES SE COLGABAN LOS PLIEGOS YA IMPRESOS. ADEMÁS, LETRAS
                    ORNAMENTALES, DE BRONCE Y MADERA; "FRISOS" O CENEFAS; ESTAMPAS
                    RELIGIOSAS Y FIGURAS, CON LAS BROCHAS Y LOS COLORES QUE SE
                    EMPLEABA PARA ILUMINARLAS”.
                </p>
            </div>
            <div class="col-sm-12 text-right mt-3 mb-3 text-white">
                <span class="fontMS500Italic font-24">
                    ALBERTO TAURO, 1996<br><br>
                </span>
            </div>
            <div class="col-sm-12">
                <img src="\assets\images\general\LINEA_RESALTE_BLANCA.png" class="reflejo"
                    width="100%">
            </div>
        </div>
    </div>
</div>


<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            ANTONIO RICARDO
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS100 text-center colorPrincipal font-40">
                    (1532-1606)
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                </div>
                <p class="fontMS500 text-center font-24">
                    <br><br>
                    EL IMPRESOR DE ORIGEN ITALIANO OFICIÓ COMO TIPÓGRAFO EN SU TRÁNSITO POR DIVERSAS CIUDADES ESPAÑOLAS. 
                    EN 1570, FUE AUTORIZADO SU VIAJE A LA NUEVA ESPAÑA (MÉXICO), EN DONDE INSTALA SU TALLER.
                </p>
                <p class="fontMS100 font-24 text-justify">
                    Conocedor que los renovados esfuerzos de evangelización de los naturales en el virreinato del
                    Perú necesitarían de la implementación de un taller para la producción de los textos doctrinarios,
                    se instala en la ciudad de Lima con los auspicios de la orden jesuita, en 1581. Aunque hubo de
                    esperar hasta 1584 para contar con la autorización real y poder imprimir, durante dos décadas, la
                    primera imprenta de Sudamérica a cargo de Ricardo, contribuyó a edificar el aparato colonial con
                    sus libros. Solo ha llegado hasta nosotros medio centenar de esos trabajos.
                </p>
            </div>
        </div>
        <div class="row bottom_cel">
            <div class="col libro">
                <a href="https://hdl.handle.net/20.500.14428/69708" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio22/IMPRENTA-010.jpg">
                    <div class="overlay-img4">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Symbolo Catholico indiano, en el qual se declaran los mysterios 
                                de la fe contenidos en los tres symbolos Catholicos, 
                                <br>
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col libro">
                <a href="https://hdl.handle.net/20.500.14428/69698" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio22/IMPRENTA-011.jpg">
                    <div class="overlay-img4">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Constitvciones y ordenancas de la vniversidad, y stvdio general de la ciudad 
                                de los Reyes del Piru.
                                <br>
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col libro">
                <a href="https://hdl.handle.net/20.500.14428/69704" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio22/IMPRENTA-012.jpg">
                    <div class="overlay-img4">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Arte, y vocabulario en la lengua general del Peru llamada Quichua y 
                                en la lengua española
                                <br>
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col libro">
                <a href="https://hdl.handle.net/20.500.14428/13066" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio22/IMPRENTA-013.jpg">
                    <div class="overlay-img4">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Doctrina christiana, y catecismo para instrvccion de los indios, y de las de mas personas, 
                                que han de ser enseñadas en nuestra sancta fé
                                <br>
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col libro">
                <a href="https://hdl.handle.net/20.500.14428/69692" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio22/IMPRENTA-014.jpg">
                    <div class="overlay-img4">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Confessionario para los curas de indios : con la instrucion contra sus ritos
                                <br>
                            </span>
                        </p>
                    </div>
                </a>
            </div>
        </div>
        <!--RESPONSIVE-->
        <div class="row c100">
            <div class="col-sm-2 libro mt-3">
                <a href="https://hdl.handle.net/20.500.14428/69708" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio22/IMPRENTA-010.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Symbolo Catholico indiano, en el qual se declaran los mysterios 
                                de la fe contenidos en los tres symbolos Catholicos, 
                                <br>
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 libro mt-3">
                <a href="https://hdl.handle.net/20.500.14428/69698" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio22/IMPRENTA-011.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Constitvciones y ordenancas de la vniversidad, y stvdio general de la ciudad 
                                de los Reyes del Piru.
                                <br>
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 libro mt-3">
                <a href="https://hdl.handle.net/20.500.14428/69704" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio22/IMPRENTA-012.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Arte, y vocabulario en la lengua general del Peru llamada Quichua y 
                                en la lengua española
                                <br>
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 libro mt-3">
                <a href="https://hdl.handle.net/20.500.14428/13066" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio22/IMPRENTA-013.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Doctrina christiana, y catecismo para instrvccion de los indios, y de las de mas personas, 
                                que han de ser enseñadas en nuestra sancta fé
                                <br>
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 libro mt-3">
                <a href="https://hdl.handle.net/20.500.14428/69692" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio22/IMPRENTA-014.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Confessionario para los curas de indios : con la instrucion contra sus ritos
                                <br>
                            </span>
                        </p>
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>


<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada4.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            FRANCISCO DEL CANTO
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada4.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS100 text-center colorPrincipal font-40">
                    (¿1552-1620?)
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                </div>
                <p class="fontMS500 text-center font-24">
                    <br><br>
                    EL SEGUNDO DE LOS IMPRESORES DE LA CIUDAD DE LIMA. ORIUNDO DE MEDINA
                    DEL CAMPO EN VALLADOLID, LLEGA AL PERÚ CON EL OFICIO FAMILIAR DE
                    TIPÓGRAFO, PERO SE ESTABLECE COMO LIBRERO EN 1586 JUNTO A SU
                    HERMANO. ES CONVOCADO POR ANTONIO RICARDO Y EMPLEADO COMO “OFICIAL DE IMPRENTA”.  
                </p>
                <p class="fontMS100 font-24 text-center">
                    En 1604 adquiere su licencia de impresor y desde 1605, año en que adquiere el taller de su
                    maestro, perfeccionó técnicamente la labor tipográfica, la diagramación y la composición a lo
                    largo de trece años.
                </p>
            </div>

            <div class="row mt-5">
                <div class="col-sm-4 mt-3 libro">
                    <a href="https://hdl.handle.net/20.500.14428/69899" target="_blank" style="color: black;">
                        <img width="100%" height="100%"
                        src="/assets/images/micrositio/micrositio22/IMPRENTA-015.jpg">
                        <div class="overlay">
                            <p class="fontMS100 text-center">
                                <span class="fontMS100">
                                    Relacion de las fiestas qve en la civdad del Cvzco se hizieron por la beatificacion del Bienaventvrado Padre 
                                    <br>
                                </span>
                            </p>
                        </div>
                    </a>
                </div>
                <div class="col-sm-4 mt-3 libro">
                    <a href="https://hdl.handle.net/20.500.14428/13669" target="_blank" style="color: black;">
                        <img width="100%" height="100%"
                        src="/assets/images/micrositio/micrositio22/IMPRENTA-016.jpg">
                        <div class="overlay">
                            <p class="fontMS100 text-center">
                                <span class="fontMS100">
                                    Relacion de las exequias q el exmo sor D Juan de Mendoca y Luna Marques de Montesclaros Virrei del Piru 
                                    hizo en la muerte de la Reina Nuestra S Doña Margarita
                                    <br>
                                </span>
                            </p>
                        </div>
                    </a>
                </div>
                <div class="col-sm-4 mt-3 libro">
                    <a href="https://hdl.handle.net/20.500.14428/13750" target="_blank" style="color: black;">
                        <img width="100%" height="100%"
                        src="/assets/images/micrositio/micrositio22/IMPRENTA-017.jpg">
                        <div class="overlay">
                            <p class="fontMS100 text-center">
                                <span class="fontMS100">
                                    Arte y vocabvlario en la lengva general del Perv llamada quichua y en la lengua española 
                                    <br>
                                </span>
                            </p>
                        </div>
                    </a>
                </div>
            </div>

            <div class="row mt-5">
                <div class="col-sm-4 mt-3 libro">
                    <a href="https://hdl.handle.net/20.500.14428/13451" target="_blank" style="color: black;">
                        <img width="100%" height="100%"
                        src="/assets/images/micrositio/micrositio22/IMPRENTA-018.jpg">
                        <div class="overlay">
                            <p class="fontMS100 text-center">
                                <span class="fontMS100">
                                    Iusta Literaria que mandó publicar el Doctor Ioán de Soto Rector de la Real Universidad de 
                                    Lima en la venida del Excelentísimo Señor Don Francisco de Borja
                                    <br>
                                </span>
                            </p>
                        </div>
                    </a>
                </div>
                <div class="col-sm-4 mt-3 libro">
                    <a href="https://hdl.handle.net/20.500.14428/13453" target="_blank" style="color: black;">
                        <img width="100%" height="100%"
                        src="/assets/images/micrositio/micrositio22/IMPRENTA-019.jpg">
                        <div class="overlay">
                            <p class="fontMS100 text-center">
                                <span class="fontMS100">
                                    Don Francisco de Borja Príncipe de Esqvilache Conde de Mayalde Gentil Hombre de la 
                                    Cámara del Rey nuestro señor su Virrey, 
                                    Lugarteniente, Governador y Capitán 
                                    <br>
                                </span>
                            </p>
                        </div>
                    </a>
                </div>
                <div class="col-sm-4 mt-3 libro">
                    <a href="https://hdl.handle.net/20.500.14428/69697" target="_blank" style="color: black;">
                        <img width="100%" height="100%"
                        src="/assets/images/micrositio/micrositio22/IMPRENTA-020.jpg">
                        <div class="overlay">
                            <p class="fontMS100 text-center">
                                <span class="fontMS100">
                                    Laberinto de Comercio terrestre y Naval, donde breve y compendiosamente se 
                                    trata de la mercancía y contratación de tierra y mar
                                    <br>
                                </span>
                            </p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40">
                    LAS ESTAMPAS RELIGIOSIDAD VIRREINAL
                </p>
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS100 text-center colorPrincipal font-40">
                            Y SUS FIGURAS DE DEVOCIÓN
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                </div>
                <p class="fontMS500 text-center font-24">
                    <br><br>
                    POR SU IMPORTANCIA Y DIFUSIÓN EN EL VIRREINATO DEL PERÚ, A LAS ESTAMPAS DE LA ICONOGRAFÍA CATÓLICA 
                    FUERON AMPLIAMENTE DIFUNDIDAS EN EL VIRREINATO DEL PERÚ. A FINES DEL SIGLO XVI APARECEN COMO 
                    ILUSTRACIONES DE LIBROS QUE DABAN CUENTA DE LAS ADVOCACIONES MÁS POPULARES O TAMBIÉN CIRCULABAN EN 
                    LÁMINAS SUELTAS DEVOCIONALES.
                </p>
                <p class="fontMS100 font-24 text-center">
                    Las estampas se difundieron en todos los niveles de la sociedad durante todo el periodo colonial
                    revelando el predominio de la temática religiosa definida por el espíritu evangelizador. En algunos
                    casos la imagen conserva una correspondencia con la escultura o pintura que representaba, relación
                    que se extendía a las órdenes o instituciones que fomentaban su devoción. Para mediados del siglo
                    XVII la producción de estampas religiosas deja de ser anónima.
                </p>
            </div>
            
            <div class="row mt-5">
                <div class="col-sm-2"></div>
                <div class="col-sm-8 libro">
                    <a href="http://hdl.handle.net/20.500.14428/79259" target="_blank" style="color: black;">
                        <img width="100%" height="100%"
                        src="/assets/images/micrositio/micrositio22/IMPRENTA-021.jpg">
                        <div class="overlay-img5">
                            <p class="fontMS100 text-center">
                                <span class="fontMS100">
                                    Marcelo Cabello<br>
                                    Nuestra Señora del Rosario de Chiquinquirá<br>
                                    Lima, Ca. principios siglo XIX<br>
                                </span>
                            </p>
                        </div>
                    </a>
                </div>
                <div class="col-sm-2"></div>
            </div>

            <div class="row mt-5">
                <div class="col-sm-4">
                    <div class="libro mt-3">
                        <a href="http://hdl.handle.net/20.500.14428/79254" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                            src="/assets/images/micrositio/micrositio22/IMPRENTA-022.jpg">
                            <div class="overlay-img6">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS100">
                                        Señor de los Milagros<br>
                                        Lima, 1715
                                        <br>
                                    </span>
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="libro mt-3">
                        <a href="http://hdl.handle.net/20.500.14428/79257" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                            src="/assets/images/micrositio/micrositio22/IMPRENTA-025.jpg">
                            <div class="overlay-img6">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS100">
                                        Nuestra Señora de las Cabezas<br>
                                        Lima, 1746
                                        <br>
                                    </span>
                                </p>
                            </div>
                        </a>
                    </div>
                    
                </div>

                <div class="col-sm-4">
                    <div class="libro mt-5">
                        <a href="http://hdl.handle.net/20.500.14428/79255" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                            src="/assets/images/micrositio/micrositio22/IMPRENTA-023.jpg">
                            <div class="overlay-img6">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS100">
                                        Verdadera efigie del Señor del Auxilio<br>
                                        Lima, 1739

                                        <br>
                                    </span>
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="libro mt-3">
                        <a href="http://hdl.handle.net/20.500.14428/79258" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                            src="/assets/images/micrositio/micrositio22/IMPRENTA-026.jpg">
                            <div class="overlay-img6">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS100">
                                        Marcelo Cabello<br>
                                        Regina Sacrastissimi Rosari Ora Pro Nobis<br>
                                        Lima, Ca. fines siglo XIX
                                    </span>
                                </p>
                            </div>
                        </a>
                    </div>
                </div>

                <div class="col-sm-4">
                    <div class="libro mt-3">
                        <a href="http://hdl.handle.net/20.500.14428/79256" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                            src="/assets/images/micrositio/micrositio22/IMPRENTA-024.jpg">
                            <div class="overlay-img6">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS100">
                                        N.S. de las Mercedes
                                        Lima, Ca. primera mitad siglo XVIII
                                        <br>
                                    </span>
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="libro mt-3">
                        <a href="http://hdl.handle.net/20.500.14428/79260" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                            src="/assets/images/micrositio/micrositio22/IMPRENTA-027.jpg">
                            <div class="overlay-img6">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS100">
                                        Nuestra Señora de Characato<br>
                                        Lima, 1805
                                    </span>
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LOS TÚMULOS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40">
                    FUNERARIOS
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                </div>
                <p class="fontMS500 text-center font-24 text-white">
                    <br><br>
                    AL IGUAL QUE EN LA METRÓPOLI ESPAÑOLA, LA CAPITAL DEL VIRREINATO SE
                    CONVIRTIÓ EN EL ESCENARIO DE CEREMONIAS Y FIESTAS NO SÓLO RELIGIOSAS
                    SINO TAMBIÉN DE CARÁCTER POLÍTICO, COMO AQUELLAS CELEBRADAS POR
                    NACIMIENTOS Y PROCLAMACIONES DE REYES O POR LA LLEGADA DE LOS
                    VIRREYES, COMPRENDIENDO TAMBIÉN LAS CEREMONIAS FÚNEBRES, BAJO LA
                    DENOMINACIÓN DE FIESTAS LUCTUOSAS.
                    <br><br>
                </p>
                <p class="fontMS100 font-24 text-white text-center">
                    Estas se expresaban por medio de la construcción de aparatos arquitectónicos efímeros levantados
                    en la Catedral de Lima en las que intervinieron arquitectos, escultores, pintores y poetas. Los libros de
                    exequias editados por las imprentas limeñas desde la primera mitad del siglo XVII contenían, en
                    detalle, todo el acontecimiento propiciado desde la llegada de la noticia del fallecimiento en España
                    del personaje real; los preparativos para la ceremonia, el protocolo en las procesiones, los sermones
                    y una descripción de la estructura arquitectónica diseñada generalmente por un arquitecto de
                    prestigio en Lima. Al final se incluía un grabado de la obra efímera.
                </p>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-sm-3 libro mt-3">
                <a href="http://hdl.handle.net/20.500.14428/79271" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio22/IMPRENTA-028.jpg">
                    <div class="overlay-img7">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Túmulo funerario del Rey Carlos II<br>
                                Miguel Adame<br>
                                Lima, 1701
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-3 libro mt-3">
                <a href="http://hdl.handle.net/20.500.14428/79250" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio22/IMPRENTA-029.jpg">
                    <div class="overlay-img7">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Túmulo funerario de Clemente XIVI<br>
                                Joseph Vásquez<br>
                                Lima, 1777<br>
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-3 libro mt-3">
                <a href="http://hdl.handle.net/20.500.14428/79272" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio22/IMPRENTA-030.jpg">
                    <div class="overlay-img7">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Túmulo funerario del Papa Benedicto XIII <br>
                                Miguel Adame<br>
                                Lima, 1731
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-3 libro mt-3">
                <a href="http://hdl.handle.net/20.500.14428/79251" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio22/IMPRENTA-031.jpg">
                    <div class="overlay-img7">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Túmulo funerario del rey Fernando VI<br>
                                Bejarano ¿Camacho?<br>
                                Lima, 1760
                            </span>
                        </p>
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            VÁZQUEZ Y CABELLO
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS100 text-center colorPrincipal font-40">
                    ARTISTAS DEL BURIL
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                </div>
                <p class="fontMS500 text-center font-24">
                    <br><br>
                    EL GRABADO CALCOGRÁFICO INCREMENTA SU PRODUCCIÓN Y HACIA MITAD
                    DEL SIGLO XVII LAS ESTAMPAS RESULTANTES EMPIEZAN A SER FIRMADAS POR EL
                    ARTISTA GRABADOR ENCARGADO DE LLEVAR A LA PLANCHA DE COBRE LA
                    IMAGEN QUE SERÍA REPRODUCIDA EN ALGUNA DE LAS IMPRENTAS
                    AUTORIZADAS EN LA CIUDAD.
                    <br>
                </p>
                <p class="fontMS100 font-24 text-justify">
                    El siglo XVIII puede considerarse como el de mayor producción calcográfica en Lima,
                    sobresaliendo las gubias de José Vázquez y Marcelo Cabello, quienes cuentan con un amplio
                    repertorio iconográfico entre los cuales se encuentran los retratos de reyes, autoridades
                    virreinales, militares, eclesiásticas y civiles. Además de la elaboración de planos de túmulos
                    funerarios, estampas religiosas y mapas, en sus trabajos se puede apreciar el tránsito del estilo
                    barroco hacia el neoclásico.
                    <br><br>
                </p>
                <p class="fontMS100 font-24 text-justify">
                    Vázquez ejerce su oficio por treinta y seis años, entre 1759 y 1794, y Cabello incluso continúa 
                    trabajando durante los primeros años de la república, hasta 1825.
                </p>
            </div>

            <div class="row mt-5">
                <div class="col-sm-6 mt-3 libro">
                    <a href="http://hdl.handle.net/20.500.14428/79253" target="_blank" style="color: black;">
                        <img width="100%" height="100%"
                        src="/assets/images/micrositio/micrositio22/IMPRENTA-032.jpg">
                        <div class="overlay-img8">
                            <p class="fontMS100 text-center">
                                <span class="fontMS100">
                                    Marcelo Cabello<br>
                                    Santa Rosa de Lima verdadero retrato<br>
                                    Lima, Ca. Fines siglo XIX
                                </span>
                            </p>
                        </div>
                    </a>
                </div>
                <div class="col-sm-6 mt-3 libro">
                    <a href="http://hdl.handle.net/20.500.14428/79252" target="_blank" style="color: black;">
                        <img width="100%" height="100%"
                        src="/assets/images/micrositio/micrositio22/IMPRENTA-033.jpg">
                        <div class="overlay-img8">
                            <p class="fontMS100 text-center">
                                <span class="fontMS100">
                                    Joseph Vázquez<br>
                                    Nave y ábside de iglesia de Las Nazarenas
                                </span>
                            </p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="fondoOrange">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 130%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO1.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS500 text-white font-28">
                            La imprenta de Antonio Ricardo asentada en Lima fue la primera de Sudamérica. 
                            Él tuvo que conseguir la autorización de la corona y solo podía imprimir textos 
                            religiosos. Te proponemos reflexionar sobre el desarrollo de la imprenta y la 
                            importancia del libro en nuestra historia y sociedad. 
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="row mt-4">
                        <div class="col-sm-4">
                            <p class="fontMS500  text-white font-28">
                                Los primeros textos que se imprimieron en Lima durante el periodo colonial trataban 
                                sobre el credo católico y sobre temas jurídicos del virreinato. ¿Por qué crees que 
                                estos temas eran importantes en aquella época?
                                <br><br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <p class="fontMS500  text-white font-28">
                                Los libros nos permiten aproximarnos y entender las sensibilidades y conocimientos 
                                de un individuo o una comunidad. En algunas ocasiones hay temas que se censuran. 
                                Te proponemos indagar sobre la censura de libros en la actualidad, ¿cuáles son 
                                los motivos para censurar un libro en el presente?
                                <br><br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <p class="fontMS500  text-white font-28">
                                Las bibliotecas públicas son los lugares donde los lectores pueden tener acceso sin 
                                restricción a la literatura, los saberes, las ideas y culturas. Coméntanos qué bibliotecas 
                                conoces y cuál es tu relación con esta. 
                                <br><br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <img class="bottom_cel" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                    <div class="col-sm-4">
                        <img class="bottom_cel" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                    <div class="col-sm-4">
                        <img class="bottom_cel" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec2" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec2" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                </div>
            </div>
            <div class="col-sm-12">
                <p class="font-24 text-gris">
                    <br><br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
            </div>
            <div class="col-sm-6">
                <p class="font-24">
                    <span class="fontMS500">Carman, Carolina (2004)</span><br>
                    <span class="fontMS100Italic text-gris">
                        Una aproximación al estudio de la producción
                        de textos para la evangelización en el Perú
                        colonial (1580-1650). En: Bibliographica
                        americana: revista interdisciplinaria de
                        estudios coloniales N°2. <br>
                    </span>
                    <span class="text-gris">
                        Biblioteca Nacional Mariano Moreno de la
                        República Argentina<br>
                    </span>
                    <a href="https://catalogo.bn.gov.ar/F/?func=direct&doc_number=001352598&local_base=GENER" target="_blank"
                        style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
                <p class="font-24">
                    <span class="fontMS500">Cuya Sialer, A. (2018)<br>
                    </span>
                    <span class="fontMS100Italic text-gris">
                        El establecimiento formal del negocio de
                        venta de libros en Perú: los casos de Juan
                        Jiménez del Río, Pedro Durango de Espinosa
                        y Andrés de Hornillos (1580-1620). En:
                        Histórica N° 42, pp. 7-57.
                    </span>
                    <span class="text-gris">Pontificia Universidad Católica del Perú<br></span>
                    <a href="https://revistas.pucp.edu.pe/index.php/historica/article/view/20264" target="_blank"
                        style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
                <p class="font-24">
                    <span class="fontMS500">Estabridis, Ricardo (2002)<br></span>
                    <span class="fontMS100Italic text-gris">
                        El grabado en Lima virreinal: documento
                        histórico y artístico, siglos XVI al XIX.
                    </span>
                    <span class="text-gris">
                        Fondo Editorial Universidad Nacional Mayor
                        de San Marcos, Lima<br>

                    </span>
                    <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=284606"
                        target="_blank" style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
            </div>
            <div class="col-sm-6">
                <p class="font-24">
                    <span class="fontMS500">Guibovich, Pedro (2013)<br></span>
                    <span class="fontMS100Italic text-gris">Lecturas prohibidas: la censura inquisitorial
                        en el Perú tardío colonial.<br>
                    </span>
                    <span class="text-gris">
                        Pontificia Universidad Católica del Perú,
                        Fondo Editorial, Lima<br>
                    </span>
                    <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=431413"
                        target="_blank" style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
                <p class="font-24">
                    <span class="fontMS500">Hampe, Teodoro (2009)<br></span>
                    <span class="fontMS100Italic text-gris">Bibliotecas, imprentas y difusión de noticias
                        en el Perú colonial. En: Bibliographica
                        americana: revista interdisciplinaria de
                        estudios coloniales N° 5.<br>
                    </span>
                    <span class="text-gris">
                        Biblioteca Nacional Mariano Moreno de la
                        República Argentina<br>
                    </span>
                    <a href="https://catalogo.bn.gov.ar/F/?func=direct&doc_number=001353084&local_base=GENER"
                        target="_blank" style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
                <p class="font-24">
                    <span class="fontMS500">PESSCA<br></span>
                    <span class="fontMS100 text-gris">Project on the Engraved Sources of Spanish
                        Colonial Art PESSCA documenta la influencia de
                        los grabados europeos en el arte colonial
                        hispanoamericano.<br>
                    </span>
                    <span class="text-gris">PESSCA brinda más de 2000
                        emparejamientos de obras de arte colonial
                        con obras originales europeas que sirvieron
                        de modelos.<br> </span>

                    <a href="https://colonialart.org/" target="_blank"
                        style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
            </div>
        </div>
    </div>
</div>
<!-- Footer -->